import productionConfig from './production';
import developmentConfig from './development';
import localDevelopmentConfig from './development.local';
import stagingConfig from './staging';
import validationConfig from './validation';

let envConfig = {};

window.envConfig = envConfig;

if (window.location.origin.match(/^\bhttps?:\/\/\S+\.securetempus\.com\b/i)) {
  envConfig = productionConfig;
} else if (window.location.origin.match(/^\bhttps?:\/\/\S+\.stagingtempus\.com\b/i)) {
  envConfig = stagingConfig;
} else if (window.location.origin.match(/^\bhttps?:\/\/\S+\.devtempus\.com\b/i)) {
  envConfig = developmentConfig;
} else if (window.location.origin.match(/^\bhttps?:\/\/\S+\.validationtempus\.com\b/i)) {
  envConfig = validationConfig;
} else {
  envConfig = localDevelopmentConfig;
}

export default envConfig;
